import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=bb383998&scoped=true"
import script from "./Service.vue?vue&type=script&lang=ts"
export * from "./Service.vue?vue&type=script&lang=ts"
import style0 from "./Service.vue?vue&type=style&index=0&id=bb383998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb383998",
  null
  
)

export default component.exports